'use strict';

class EventView {
  constructor($scope, $sce, $location, $timeout, $rootScope, eventService, commonService, validationService, I18N, Notification, vcRecaptchaService) {
    this.$scope = $scope;
    this.$sce = $sce;
    this.$location = $location;
    this.$timeout = $timeout;
    this.$rootScope = $rootScope;
    this.eventService = eventService;
    this.commonService = commonService;
    this.validationService = validationService;
    this.I18N = I18N;
    this.Notification = Notification;
    this.vcRecaptchaService = vcRecaptchaService;
  }

  $onInit() {
    var noParam = this.$location.absUrl().split('?')[0];
    this.id = noParam.split('/')[4];

    this.error = {};
    this.captchaResponse = null;

    this.discount = {
      amount: 0,
      type: 'AMOUNT'
    };

    this.event = {
      price: 0,
      customFields: []
    };

    this.eventInvoice = {
      name: null,
      email: null,
      mobile: null,
      invoice: {
        name: null,
        zip: null,
        address: null,
        city: null,
        country: 'NORGE',
        orgNo: null,
        icd: '9908',
        yourRef: null
      },
      customFields: []
    };
    this.countries = [];
    this.total = 0;
    this.signedUp = false;

    this.loadCountries();
    this.load();
    $('.container').fadeIn();

    this.$scope.$watch('vm.event.customFields', () => {
      this.calculatePrice();
    }, true);
  }

  shareFb() {
    FB.ui({
      method: 'feed',
      name: this.event.name,
      link: `https://www.sendregning.no/arrangement/${this.event.id}`,
      description: this.event.description
    });
  }

  loadCountries() {
    this.countries = ['NORGE'];
    this.commonService.getCountries()
      .then((resp) => {
        this.countries = resp;
      });
  }

  load() {
    this.loading = true;

    this.eventService.getEventInfo(this.id)
      .then((resp) => {
        this.loading = null;
        this.event = resp.data;
        this.event.description = this.$sce.trustAsHtml(resp.data.description);
        this.$rootScope.pageTitle = this.event.name;
        this.calculatePrice();
      }, () => {
        this.loading = null;
      });
  }

  validateDiscountCode() {
    this.discount.amount = 0;

    if (this.event.discountCodes.code !== null || this.event.discountCodes.code !== '') {
      this.eventService.validateDiscountCode(this.id, this.event.discountCodes.code)
        .then((resp) => {
          this.discount.amount = resp.data.amount;
          this.discount.type = resp.data.type;
          this.calculatePrice();
        });
    } else {
      this.discount.amount = 0;
      this.calculatePrice();
    }
  }

  getCityByZip() {
    if (this.eventInvoice.invoice.zip && this.eventInvoice.invoice.country === 'NORGE') {
      if (this.eventInvoice.invoice.zip.length === 4) {
        this.commonService.getCityByPostCode(this.eventInvoice.invoice.zip)
          .then((resp) => {
            this.eventInvoice.invoice.city = resp.data.city ? resp.data.city : 'OLSO';

            this.$timeout(() => {
              $('#city').select();
            }, 300);
          });
      }
    }
  }

  formatDate(date) {
    if (date) {
      return moment(date, 'YYYY-MM-DD HH:mm').format('dddd D MMM YYYY HH:mm');
    }
  }

  calculatePrice() {
    this.total = this.event.price;

    if (this.event.customFields && this.event.customFields.length) {
      this.event.customFields.forEach((cf) => {
        // NUMBER (total + value x price)
        if (cf.type === 'NUMBER' && cf.value !== 0 && !isNaN(cf.value)) {
          if (cf.price && cf.price.price !== null) {
            this.total += cf.value * cf.price.price;
          }
        }

        // BOOLEAN (total + price)
        else if (cf.type === 'BOOLEAN' && cf.value) {
          if (cf.price && cf.price.price !== null) {
            this.total += cf.price.price;
          }
        }

        // ENUM (value x price)
        else if (cf.type === 'TEXT' && cf.options !== null) {
          cf.options.forEach((o) => {
            if (o.value === cf.value) {
              if (o.price && o.price.price !== null) {
                this.total += o.price.price;
              }
            }
          }, this);
        }
      }, this);
    }

    if (this.discount.amount !== 0) {
      if (this.discount.type === 'AMOUNT') {
        this.total -= this.discount.amount;
      } else if (this.discount.type === 'PERCENTAGE') {
        this.total = this.total * (100 - this.discount.amount) / 100;
      }
    }
  }

  isPast() {
    return this.event.registrationDeadline && moment(this.event.date).diff(this.event.registrationDeadline) > 0;
  }

  signup() {
    $('button.submit').prop('disabled', true);

    this.event.customFields.forEach((item) => {
      if (item.type === 'DATE') {
        if (item.value) {
          item.value = moment(item.value, 'DD.MM.YYYY').format('YYYY-MM-DD');
        }
      }

      return item;
    });

    this.eventInvoice.customFields = this.event.customFields;

    if (this.event.discountCodes) {
      if (this.event.discountCodes.code !== null || this.event.discountCodes.code !== '') {
        this.eventInvoice.discountCode = this.event.discountCodes.code;
      }
    }

    if (this.event._links.signup) {
      this.eventService.signUp(this.event._links.signup.uri, this.eventInvoice, this.captchaResponse)
        .then(() => {
          $('.alert-box.system').remove();
          this.error = {};
          this.Notification.success('Din p&aring;melding er registrert');
          this.signedUp = true;
          $('button.submit').prop('disabled', false);
        })
        .catch(() => {
          $('button.submit').prop('disabled', false);
          this.vcRecaptchaService.reload();
        });
    } else {
      this.Notification.error(this.I18N.general.systemError);
      $('button.submit').prop('disabled', false);
    }
  }
}

EventView.$inject = ['$scope', '$sce', '$location', '$timeout', '$rootScope', 'eventService', 'commonService', 'validationService', 'I18N', 'Notification', 'vcRecaptchaService'];

angular
  .module('SendRegning')
  .controller('EventView', EventView);
